import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z6() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    const items: any = [
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z6-1.webp')}
                    src={require('@publicLocal/delta2max/teaser/pc/eu/z6-1.jpg')}
                    alt={t('sec6_desc_inside')}
                    aria-label={t('sec6_desc_inside')}
                />
            ),
            text: t('sec6_desc_inside'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z6-2.webp')}
                    src={require('@publicLocal/delta2max/teaser/pc/eu/z6-2.jpg')}
                    alt={t('sec6_desc_out')}
                    aria-label={t('sec6_desc_out')}
                />
            ),
            text: t('sec6_desc_out'),
        },
    ];

    return (
        <div className={`d2x-Z6 ${css.d2xZ6} GtmModuleData-section`} data-section-id={css.d2xZ6} data-section-title={t('sec6_title')}>
            <div className="sec6">
                <p className="title">{t('sec6_title')}</p>
                <ul className="cards">
                    {items?.map((item: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="img">{item?.img}</div>
                            <p className="text">{item?.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
